<template>
	<div class="lightbox" @click.self="clickLightbox">
		<div class="lightbox-body" v-if="!$store.state.lightboxImage">
			<the-lightbox-form @submitted="onSubmitted" v-if="showForm" />
			<the-lightbox-confirmation v-if="!showForm" @reopen="reopen" />
			<a href="#close" @click.prevent="closeLightbox" class="lightbox-body__close">&times;</a>
		</div>
		<div class="lightbox-body" v-if="$store.state.lightboxImage">
			<img :src="lightboxImage">
			<a href="#close" @click.prevent="closeLightbox" class="lightbox-body__close">&times;</a>
		</div>
	</div>
</template>

<script>
import TheLightboxForm from './TheLightboxForm';
import TheLightboxConfirmation from './TheLightboxConfirmation';

export default {
	components: { TheLightboxForm, TheLightboxConfirmation },
	data () {
		return {
			form: true,
		};
	},
	computed: {
		showForm () {
			return this.form === true && !localStorage.getItem('submitted');
		},
		lightboxImage () {
			return require(`../assets/photo-0${this.$store.state.lightboxImage}-big.jpg`);
		},
	},
	methods: {
		onSubmitted () {
			this.form = false;
		},
		closeLightbox () {
			this.$root.dispatchEvent('formClose');
			this.$emit('hideLightbox');
		},
		clickLightbox (e) {
			this.$root.dispatchEvent('formClose');
			this.$emit('hideLightbox');
		},
		reopen (e) {
			this.$emit('hideLightbox');
			this.$emit('reopen');
		},
	},
};
</script>

<style lang="less" scoped>
	@import (reference) '../assets/_mixins.less';
	@import (reference) '../assets/_breakpoints.less';

	.lightbox { display: flex; align-items: center; .top-left-f(0, 0, 100); bottom: 0; right: 0; .size(100%); .bgc(fade(#000000, 80)); }
	.lightbox-body { position: relative; display: flex; flex-direction: column; align-items: center; max-width: 575px; background-color: #fff;
		&__offer { .size(100%, 50px); .bgc(#D6D6D6); text-align: center; }
		&__close { .top-right(); padding: 0.6ex 1.2ex; background-color: #e60017; color: white; font-weight: 600; font-size: 22px; }
	}

	// Wide screens lightbox cut fix.
	.lightbox { overflow: hidden; overflow-y: auto; }
	.lightbox-body { margin: auto; }

	@media @mobile {
		.lightbox-body { max-height: 100vh; padding-bottom: 10vh; overflow: hidden; overflow-y: auto; }
	}
</style>




// WEBPACK FOOTER //
// src/components/TheLightbox.vue